import { Injectable          } from '@angular/core';
import { LoginError          } from 'src/app/errors/login.errors';
import { Result              } from 'src/app/beans/result/result.bean';
import { RequestError        } from 'src/app/enums/network/request/error/requestError.enum';
import { TokenError          } from 'src/app/errors/token.errors';
import { LogoutError         } from 'src/app/errors/logout.errors';
import { PasswordChangeError } from 'src/app/errors/password.change.error';
import { StatisticsError     } from 'src/app/errors/statistics.error';
import { Authentication      } from 'src/app/errors/authentication.errors';
import { SlotError           } from 'src/app/errors/slot.errors';
import { DeviceCalendar      } from 'src/app/errors/device_calendar.errors';
import { Callmode            } from 'src/app/errors/callmode.errors';
import { CounterService      } from 'src/app/errors/counter_service.errors';
import { ServiceCalendar     } from 'src/app/errors/service_calendar.errors';
import { OperatorError       } from 'src/app/errors/operator.errors';
import { MessageError        } from 'src/app/errors/message.errors';
import { GenericError        } from 'src/app/errors/generic.errors';
import { DeviceError         } from 'src/app/errors/device.error';

@Injectable
({
  providedIn: 'root'
})

export class ErrorManager
{
    constructor(
      private _login           : LoginError          ,
      private _logout          : LogoutError         ,
      private _password_change : PasswordChangeError ,
      private _token           : TokenError          ,
      private _device          : DeviceError         ,
      private _device_calendar : DeviceCalendar      ,
      private _service_calendar: ServiceCalendar     ,
      private _callmode        : Callmode            ,
      private _counter_service : CounterService      ,
      private _operator        : OperatorError       ,
      private _message         : MessageError        ,
      private _statistics      : StatisticsError     ,
      private _slot            : SlotError           ,
      private _auth            : Authentication      ,
      private _generic         : GenericError        ,
    ) {}

    hasError(resp: any)
    {


      if(!Result.isKind(resp)) return true
      return resp.result != 1
    }

    handleCQWebapp(resp: any, params?: any, error: boolean = true)
    {
        if(!Result.isKind(resp))
        {
          // handle generic error
          return undefined
        }

        switch(resp.result)
        {
          case RequestError.LOGIN_GENERIC                     : return this._login.generic()
          case RequestError.LOGIN_WRONG_USERNAME              : return this._login.userDoesntExists()
          case RequestError.LOGIN_WRONG_PASSWORD              : return this._login.wrongPassword()
          case RequestError.LOGIN_PASSWORD_CHANGE_REQUIRED    : return this._login.passwordChangeRequired()
          case RequestError.LOGIN_OPERATOR_NOT_AUTHORIZED     : return this._login.operatorNotAuth()
          case RequestError.LOGIN_OPERATOR_ALREDY_LOGGED      : return this._login.userAlreadyLogged( params )

          case RequestError.LOGOUT_GENERIC                    : return this._logout.generic()
          case RequestError.LOGOUT_USER_NOT_ALLOWED           : return this._logout.userNotAllowed()

          case RequestError.PASSWORD_CHANGE_GENERIC           : return this._password_change.generic()
          case RequestError.PASSWORD_CHANGE_SAMEPASSWORD      : return this._password_change.samePassword()
          case RequestError.PASSWORD_CHANGE_WRONG_PASSWORD    : return this._password_change.wrongPassword()

          case RequestError.DEVICE_CALENDAR_U_GENERIC           : return this._device_calendar.uGeneric()
          case RequestError.DEVICE_CALENDAR_U_INVALID_OPEN_TIME : return this._device_calendar.uInvalidOpenTime()
          case RequestError.DEVICE_CALENDAR_U_INVALID_CLOSE_TIME: return this._device_calendar.uInvalidCloseTime()
          case RequestError.DEVICE_CALENDAR_U_TIME_SUPERIMPOSED : return this._device_calendar.uTimeSuperimposed()
          case RequestError.DEVICE_CALENDAR_D_GENERIC           : return this._device_calendar.dGeneric()
          case RequestError.DEVICE_CALENDAR_S_GENERIC           : return this._device_calendar.sGeneric()

          case RequestError.SERVICE_CALENDAR_U_GENERIC           : return this._service_calendar.uGeneric()
          case RequestError.SERVICE_CALENDAR_U_INVALID_OPEN_TIME : return this._service_calendar.uInvalidOpenTime()
          case RequestError.SERVICE_CALENDAR_U_INVALID_CLOSE_TIME: return this._service_calendar.uInvalidCloseTime()
          case RequestError.SERVICE_CALENDAR_U_TIME_SUPERIMPOSED : return this._service_calendar.uTimeSuperimposed()
          case RequestError.SERVICE_CALENDAR_D_GENERIC           : return this._service_calendar.dGeneric()
          case RequestError.SERVICE_CALENDAR_S_GENERIC           : return this._service_calendar.sGeneric()

          case RequestError.CALLMODE_L_GENERIC                   : return this._callmode.lGeneric()
          case RequestError.CALLMODE_U_GENERIC                   : return this._callmode.uGeneric()

          case RequestError.COUNTER_SERVICE_L_GENERIC            : return this._counter_service.lGeneric()
          case RequestError.COUNTER_SERVICE_SET_GENERIC          : return this._counter_service.setGeneric()
          case RequestError.COUNTER_SERVICE_UNSET_GENERIC        : return this._counter_service.unsetGeneric()

          case RequestError.OPERATOR_ASSIGN_INVALID_LOGIN_ID  : return this._operator.invalidLoginId()
          case RequestError.OPERATOR_UNASSIGN_INVALID_LOGIN_ID: return this._operator.invalidLoginId()
          case RequestError.DEVICE_OPERATOR_INVALID_LOGIN_ID  : return this._operator.invalidLoginId()

          case RequestError.MESSAGE_INVALID_MESSAGE_ID: return this._message.invalidMessageId()

          case RequestError.MESSAGE_DELETE_INVALID_MESSAGE_ID: return this._message.invalidMessageId()

          case RequestError.MESSAGE_INVALID_DATE_SIZE: return this._message.invalidDateSize()

          case RequestError.MESSAGE_UPDATE_INVALID_MESSAGE_ID: return this._message.invalidMessageId()
          case RequestError.MESSAGE_UPDATE_INVALID_DATE_SIZE : return this._message.invalidDateSize ()

          case RequestError.SLOT_INVALID_DATE_IN                   : return  this._slot.invalidDateIn      ()
          case RequestError.SLOT_DAY_INVALID_DATE_IN               : return  this._slot.invalidDateIn      ()
          case RequestError.SLOT_LESS_CURRENT_DATE                 : return  this._slot.lessCurrentDate    ()
          case RequestError.SLOT_BOOK_NOT_EXIST                    : return  this._slot.bookNotExist       ()
          case RequestError.SLOT_BOOK_LESS_CURRENT_DATE            : return  this._slot.bookLessCurrentDate()
          case RequestError.SLOT_BOOK_ONLY_TODAY                   : return  this._slot.bookOnlyToday      ()
          case RequestError.SLOT_TIME_JUST_PASSED                  : return  this._slot.timeJustPassed     ()
          case RequestError.SLOT_PRENOTATION_EXIST                 : return  this._slot.prenotationExist   ()
          case RequestError.SLOT_TIME_UNAVAILABLE                  : return  this._slot.timeUnavailable    ()
          case RequestError.SLOT_UPDATE_BOOK_NOT_EXIST             : return  this._slot.bookNotExist       ()
          case RequestError.SLOT_INVALID_ID                        : return  this._slot.invalidId          ()
          case RequestError.SLOT_DELETE_BOOK_NOT_EXIST             : return  this._slot.bookNotExist       ()
          case RequestError.SLOT_TIME_CREATE_INVALID_DATE_IN       : return  this._slot.invalidDateIn      ()
          case RequestError.SLOT_TIME_CREATE_LESS_CURRENT_DATE     : return  this._slot.lessCurrentDate    ()
          case RequestError.SLOT_TIME_CREATE_INVALID_TIME_ID       : return  this._slot.invalidTimeId      ()
          case RequestError.SLOT_TIME_CREATE_DUPLICATED_SLOT       : return  this._slot.duplicatedSlot     ()
          case RequestError.SLOT_TIME_UPDATE_INVALID_DATE_IN       : return  this._slot.invalidDateIn      ()
          case RequestError.SLOT_TIME_UPDATE_LESS_CURRENT_DATE     : return  this._slot.lessCurrentDate    ()
          case RequestError.SLOT_TIME_UPDATE_INVALID_TIME_ID       : return  this._slot.invalidTimeId      ()
          case RequestError.SLOT_TIME_UPDATE_DUPLICATED_SLOT       : return  this._slot.duplicatedSlot     ()
          case RequestError.SLOT_TIME_UPDATE_ALREADY_BOOKED        : return  this._slot.alreadyBooked      ()
          case RequestError.SLOT_TIME_DELETE_INVALID_DATE_IN       : return  this._slot.invalidDateIn      ()
          case RequestError.SLOT_TIME_DELETE_LESS_CURRENT_DATE     : return  this._slot.lessCurrentDate    ()
          case RequestError.SLOT_TIME_DELETE_INVALID_TIME_ID       : return  this._slot.invalidTimeId      ()
          case RequestError.SLOT_TIME_DELETE_BOOKABLE_DAY_NOT_EXIST: return  this._slot.bookableDayNotExist()
          case RequestError.SLOT_TIME_DELETE_BOOKED                : return  this._slot.alreadyBooked      ()
          case RequestError.SLOT_DAY_INVALID_TYPE                  : return  this._slot.invalidType        ()
          case RequestError.SLOT_DAY_NOT_FOUND                     : return  this._slot.dayNotFound        ()

          case RequestError.STATISTIC_UNAUTH_USER             : return  this._statistics.unauthUser()
          case RequestError.STATISTIC_UNAUTH_USER_RESOURCE    : return  this._statistics.unauthUserResource()
          case RequestError.STATISTIC_INVALID_DATE_TO         : return  this._statistics.invalidDateTo()
          case RequestError.STATISTIC_WRONG_DATE_FORMAT       : return  this._statistics.invalidDateFormat()
          case RequestError.STATISTIC_INVALID_SC              : return  this._statistics.invalidServiceCounter()
          case RequestError.STATISTIC_INVALID_DT              : return  this._statistics.invalidDetailTotal()
          case RequestError.STATISTIC_INVALID_PERIOD          : return  this._statistics.invalidPeriod()
          case RequestError.STATISTIC_SPECIFY_JUST_SITE_OR_ORG: return  this._statistics.specifyJustOrgOrSite()

          case RequestError.BOOK_KEY_INVALID            : return this._generic.generic()
          case RequestError.BOOK_MODE_INVALID           : return this._generic.generic()
          case RequestError.BOOK_USER_INVALID           : return this._generic.generic()
          case RequestError.BOOK_SLOT_INVALID           : return  this._slot.bookNotExist()
          case RequestError.BOOK_PRENOTABILITY_INVALID  : return  this._slot.timeUnavailable()
          case RequestError.BOOK_TIME_ELAPSED           : return  this._slot.timeJustPassed()
          case RequestError.BOOK_ALREADY_BOOKED         : return  this._slot.alreadyBooked()

          case RequestError.DEVICE_ACTIVATION_NOT_EXIST: return this._device.deviceNotExist()

          case RequestError.USER_NOT_ALLOWED                  : return this._auth.notAllowed()

          case RequestError.TOKEN_HAS_EXPIRED                 : return this._token.hasExpired()

          default: return error ? this._generic.generic() : undefined
        }
    }

    handleNetwork ()
    {

    }
}
